export {CtaWithAvatar} from './lib/cta-with-avatar';